import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=4fbfe42b&"
import script from "./Widget.vue?vue&type=script&lang=ts&"
export * from "./Widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports